export function formatAmount(value: number | undefined): string {
  if (value === undefined || value === null) return '--';
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
